import { Claim, CommonTechnicalProfile, Enumeration } from '../xmlParsing/interfaces';

export const validateClaim = (newClaim: Claim, allClaims: any) => {
  let errorFlag: boolean = false;
  // check if id is empty or duplicate
  if (newClaim['id'] === '' || allClaims.hasOwnProperty(newClaim['id'])) {
    errorFlag = true;
  }
  // validate based on userInputType
  if (
    !errorFlag &&
    ['CheckboxMultiSelect', 'DropdownSingleSelect', 'RadioSingleSelect'].includes(newClaim['userInputType'])
  ) {
    const valList: string[] = [];
    const textList: string[] = [];
    (newClaim['enumeration'] || []).forEach((el: Enumeration) => {
      valList.push(el['value']);
      textList.push(el['text']);
    });
    // validate atleast 2 enums are there
    if (newClaim['enumeration'] && newClaim['enumeration'].length < 2) errorFlag = true;
    // check if any of the enums text or value is empty
    else if (valList.includes('') || textList.includes('')) {
      errorFlag = true;
    }
    // check if no two enums value or text field repeats
    else if (
      Array.from(new Set(valList)).length != valList.length ||
      Array.from(new Set(textList)).length != textList.length
    ) {
      errorFlag = true;
    }
  }
  // for userInputType = TextBox, validate regularExpression
  if (
    !errorFlag &&
    ['TextBox'].includes(newClaim['userInputType']) &&
    newClaim['pattern'] &&
    newClaim['pattern']['regularExpression'].trim().length === 0
  ) {
    errorFlag = true;
  }
  // validate mask
  if (
    !errorFlag &&
    newClaim['mask'] &&
    newClaim['mask']['type'] == 'Regex' &&
    newClaim['mask']['regex'].trim() === ''
  ) {
    errorFlag = true;
  }
  return errorFlag;
};

export const getTPType = (protocol: any, metadata: any) => {
  if (protocol.length <= 1) return 'none';
  else {
    const firstProtocol = protocol[0].toLowerCase();
    const secProtocol = protocol[1].toLowerCase();
    if (secProtocol.includes('selfassertedattributeprovider')) {
      return 'selfAssertedProfiles';
    } else if (secProtocol.includes('restful')) {
      return 'REST-API';
    } else if (secProtocol.includes('phonefactorprotocolprovider')) {
      return 'MFA';
    } else if (secProtocol.includes('azureactivedirectoryprovider')) {
      const aadOperation = metadata.find((metadataItem: [string, string]) => metadataItem[0] === 'Operation');
      if (aadOperation) {
        return 'AAD-' + aadOperation[1];
      }
      return 'AAD';
    } else if (secProtocol.includes('azureapplicationinsightsprovider')) {
      return 'APP-INSIGHTS';
    } else if (firstProtocol.includes('openidconnect')) {
      return 'OpenIdConnect';
    } else if (firstProtocol.includes('oauth2')) {
      return 'OAuth2';
    } else return 'Other';
  }
};

export function deepCopy<T>(instance: T): T {
  if (instance == null) {
    return instance;
  }

  // handle Dates
  if (instance instanceof Date) {
    return new Date(instance.getTime()) as any;
  }

  // handle Array types
  if (instance instanceof Array) {
    var cloneArr = [] as any[];
    (instance as any[]).forEach((value) => {
      cloneArr.push(value);
    });
    // for nested objects
    return cloneArr.map((value: any) => deepCopy<any>(value)) as any;
  }
  // handle objects
  if (instance instanceof Object) {
    var copyInstance = { ...(instance as { [key: string]: any }) } as { [key: string]: any };
    for (var attr in instance) {
      if ((instance as Object).hasOwnProperty(attr)) copyInstance[attr] = deepCopy<any>(instance[attr]);
    }
    return copyInstance as T;
  }
  // handling primitive data types
  return instance;
}

export const guidGenerator = () => {
  var S4 = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
};

export const generateId = () => `_${Math.random().toString(36).substr(2, 9)}`;

export const getNestedValue = (obj: any, ...args: any) => {
  return args.reduce((obj: any, level: any) => obj && obj[level], obj);
};
/* check circle structure
return true if tree doesn't contain the circle structure
*/
// @ts-ignore
export const isCirclic = (obj: any, origin: string, key: string) => {
  if (obj[key]?.find((unit: string) => unit === origin)) {
    return true;
  }
  for (let i = 0; i < obj[key]?.length; i++) return isCirclic(obj, origin, obj[key][i]);

  return false;
};
